export const TABLE_NAME = {
    USER_PROFILE: 'user_profiles',
    VERSIONS: 'versions',
    POSTS: 'posts',
    POSTS_VIEWED: 'viewed_posts',
    FOOTER_APP: 'footer_app',
    TRACKINGS: 'trackings',
    REACTIONS: 'reactions',
    UPLOAD_IMAGES_PENDING: 'upload_images_pending',
    ERROR_LOGS: 'error_logs',
    FORMS_TOTALS: 'forms_totals',
    GAMIFICATION_GAME_PENDING_SEND: 'game_pending_send',


    LEARNING_CATEGORIES: 'learning_categories',
    LEARNING_COURSES: 'learning_courses',
    LEARNING_CONTENTS: 'learning_contents',
    LEARNING_EVALUATIONS: 'learning_evaluations',
    LEARNING_ANSWERS_EVALUATIONS: 'answers_learning_evaluations',
    LEARNING_SAVE_PROGRESS_TRAINING: 'save_progress_training',
    LEARNING_ANSWER_SURVEY: 'answers_learning_surveys',


    PORTFOLIO_CATEGORIES: 'ecommerce_categories',
    PORTFOLIO_PRODUCTS: 'ecommerce_products',
    PORTFOLIO_BRANDS: 'ecommerce_brands',


    BENEFIT_VOUCHERS: 'benefit_vouchers',
    BENEFIT_REDEEMS: 'benefit_redeems',
    BENEFIT_POINTS_AWARDED: 'benefit_awarded_points',


    SCHEDULE_STORES: 'stores',
    SCHEDULES_POS: 'schedules_pos',
    SCHEDULE_STORE_FORMS: 'stores_forms',
    SCHEDULE_CAMPAINGS: 'campaings',
    SCHEDULES: 'schedules',
    SCHEDULE_FORMS_QUESTION_ANSWERS: 'form_question_answers',
    SCHEDULE_SCHEDULES_POS: 'schedules_pos',
    SCHEDULE_ADVANCES: 'schedules_advances',
    SCHEDULE_CHECKIN: 'transaction_checkins',
    SCHEDULE_CHECKOUT: 'transaction_checkouts',
    SCHEDULE_CHECKIN_STEPS: 'checkin_steps',
    SCHEDULE_ACTIVITIES_ADVANCES: 'schedules_activities_advances',
    SCHEDULE_ACTIVITIES_ADVANCES_PENDINGS: 'schedules_activities_advances_pendings',
    SCHEDULE_FORMS_ADDITIONALS: 'forms_additionals',
    SCHEDULE_CREATE_STORES: 'create_stores',
    SCHEDULE_FORMS_PERFECT_STORE: 'forms_perfect_stores',
    SCHEDULE_STORES_PF_RELATION: 'perfect_stores_relation',
    SCHEDULE_ASSETS_PF_LINKS: 'assets_pf_links',
    SCHEDULE_FORMS_PENDING_SYNC: 'forms_pending_sync',
    SCHEDULE_STORES_INDICATORS: 'stores_indicators',

    SCHEDULE_STORES_CREATE_COUNTRIES: 'stores_create_countries',
    SCHEDULE_STORES_CREATE_PROVINCES: 'stores_create_provinces',
    SCHEDULE_STORES_CREATE_CITIES: 'stores_create_cities',
    SCHEDULE_STORES_ORGANIZATIONS: 'stores_organizations',
    SCHEDULE_STORES_PENDING_SEND: 'stores_pending_send',
    SCHEDULE_STORES_CREATE_FIELDS: 'stores_create_fields',
    SCHEDULE_STORES_CREATE_FIELDS_ORGANIZATIONS: 'stores_create_fields_organizations',

}

export const TABLES_ARRAY = Object.values(TABLE_NAME);